import React, { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Btn, InputField } from './UIComponents';

export default function AdministerModal({ med, onClose }) {
  const [notes, setNotes] = useState('');
  const { B } = useTheme();

  const modalStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  };

  const modalContentStyle = {
    background: B.cardBg,
    borderRadius: 16,
    width: '100%',
    maxWidth: 420,
    padding: 28,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    // Mobile-specific styles
    '@media (maxWidth: 768px)': {
      width: '90%',
      padding: 16,
    },
  };

  const labelStyle = {
    fontSize: 11,
    fontWeight: 600,
    color: B.text,
    display: 'block',
    marginBottom: 3,
  };

  const textareaStyle = {
    width: '100%',
    fontSize: 12,
    padding: '7px 10px',
    borderRadius: 8,
    border: `1.5px solid ${B.border}`,
    fontFamily: 'inherit',
    color: B.text,
    background: B.inputBg,
    outline: 'none',
    resize: 'vertical',
    minHeight: 70,
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    // Mobile-specific styles
    '@media (maxWidth: 768px)': {
      flexDirection: 'column',
      gap: 8,
    },
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div
        style={modalContentStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontSize: 16, fontWeight: 800, color: B.navy, marginBottom: 6 }}>
          Administer Medication
        </div>
        {med && (
          <div style={{ fontSize: 12, color: B.muted, marginBottom: 20 }}>
            {med.name} · {med.resident} · Room {med.room}
          </div>
        )}
        <InputField label="Administered By" select options={['Alex Franklin (RN)', 'Sandra Miller (LPN)', 'Jordan Lee (CNA)']} />
        <InputField label="Time Administered" type="time" />
        <InputField label="Site (if applicable)" placeholder="e.g. Left deltoid" />
        <div style={{ marginBottom: 12 }}>
          <label style={labelStyle}>Notes</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Any observations…"
            style={textareaStyle}
          />
        </div>
        <div style={buttonContainerStyle}>
          <Btn outline color={B.muted} onClick={onClose}>
            Cancel
          </Btn>
          <Btn color={B.green} onClick={onClose}>
            ✓ Confirm Administration
          </Btn>
        </div>
      </div>
    </div>
  );
}